import { Button, Spin, Upload, UploadProps } from 'antd';
import { ReactNode, useState } from 'react';
import { UploadOutlined } from '@ant-design/icons';
import { UploadBusinessType, UploadFileType } from '../../types';

const FileUpload = ({
  onUploading,
  onUploaded,
  onError,
  businessType,
  fileType,
  children,
}: {
  onUploading?: () => void;
  onError?: (error: any) => void;
  onUploaded?: (response: any) => void;
  businessType: UploadBusinessType;
  fileType?: UploadFileType;
  children?: ReactNode;
}) => {
  const [loading, setLoading] = useState(false);

  const handleChange: UploadProps['onChange'] = (info) => {
    switch (info.file.status) {
      case 'uploading':
        setLoading(true);
        onUploading?.();
        break;
      case 'done':
        setLoading(false);
        onUploaded?.(info.file.response);
        break;
      case 'error':
        setLoading(false);
        onError?.(info.file.error);
        break;
      default:
        break;
    }
  };

  return (
    <Upload
      name="files"
      disabled={loading}
      data={{
        businessType,
        fileType: fileType || UploadFileType.DOCUMENT,
      }}
      showUploadList={false}
      headers={{
        Authorization: `Bearer ${localStorage.getItem('token')}`,
      }}
      action={`${process.env.REACT_APP_SERVICE_URL}/file`}
      onChange={handleChange}
    >
      {children || <Button icon={<UploadOutlined />}>Click to Upload</Button>}
    </Upload>
  );
};

export default FileUpload;
